import { configureStore, Tuple } from '@reduxjs/toolkit'
import { thunk } from 'redux-thunk'
import { logger } from 'redux-logger'
import rootReducer from '_reducers'

export const store = configureStore({
  reducer: rootReducer,
  middleware: () => new Tuple(thunk, logger),
})
